import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import TasksExecsListByAuthUser from '../../../../../components/Tasks/TasksExecsLists/TasksExecsListByAuthUser';

class CheckedTasksList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reducerName: `checkedTasksList`,
      queryParamsStatic: {
        status: 2
      }
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <TasksExecsListByAuthUser
        reducerName={this.state.reducerName}
        queryParamsStatic={this.state.queryParamsStatic}
      />
    );
  }
}

export default withRouter(CheckedTasksList);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/CheckedTasksList/CheckedTasksList.js